import { TFunction } from 'i18next';
import { formatSecondsSinceMidnight } from 'shared/dates';
import * as Yup from 'yup';

export const getHoursValidationSchema = (
  t: TFunction,
): Yup.ArraySchema<Yup.AnyObjectSchema> =>
  Yup.array(
    Yup.object().shape({
      dayOfWeek: Yup.number(),
      times: Yup.array()
        .of(
          Yup.object().shape({
            openTime: Yup.number()
              .nullable()
              .typeError(t('formHours.errors.invalid'))
              .test(
                'is-valid',
                t('formHours.errors.invalid'),
                function (value) {
                  if (typeof value !== 'number') {
                    return this.createError({
                      path: this.path,
                      message: t('formHours.errors.required'),
                    });
                  }
                  const formattedValue = formatSecondsSinceMidnight(value);
                  return /^(0?[1-9]|1[0-2]):([0-5][0-9])\s(am|pm)$/i.test(
                    formattedValue,
                  );
                },
              )
              .test(
                'is-after-previous-close',
                t('formHours.errors.afterPreviousClose'),
                function (value) {
                  // @ts-expect-error this.from[1] is the times array
                  const timesArray = this.from[1].value.times;
                  const currentIndex = timesArray.indexOf(this.parent);

                  // Skip validation for first time item
                  if (currentIndex === 0 || typeof value !== 'number') {
                    return true;
                  }

                  const previousCloseTime =
                    timesArray[currentIndex - 1]?.closeTime;

                  if (typeof previousCloseTime !== 'number') {
                    return true;
                  }

                  const openSeconds = value;
                  const previousCloseSeconds = previousCloseTime;

                  return openSeconds > previousCloseSeconds;
                },
              ),
            closeTime: Yup.number()
              .nullable()
              .typeError(t('formHours.errors.invalid'))
              .test(
                'is-valid',
                t('formHours.errors.invalid'),
                function (value) {
                  if (typeof value !== 'number') {
                    return this.createError({
                      path: this.path,
                      message: t('formHours.errors.required'),
                    });
                  }
                  const formattedValue = formatSecondsSinceMidnight(value);
                  return /^(0?[1-9]|1[0-2]):([0-5][0-9])\s(am|pm)$/i.test(
                    formattedValue,
                  );
                },
              )
              .test(
                'is-after-open-time',
                t('formHours.errors.afterOpenTime'),
                function (value) {
                  const { openTime } = this.parent;
                  if (
                    typeof openTime !== 'number' ||
                    typeof value !== 'number'
                  ) {
                    return true;
                  }

                  const openSeconds = openTime;
                  const closeSeconds = value;

                  return closeSeconds > openSeconds;
                },
              ),
          }),
        )
        .required(),
      checked: Yup.boolean(),
    }),
  );
